import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = { class: "login-box" }
const _hoisted_3 = { class: "card card-outline card-primary" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Exoty", -1)
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "login-box-msg" }, "Sign in to start your session", -1)
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "mt-3 mb-1 text-center" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Forgot password")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_button = _resolveComponent("app-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "card-header text-center h1"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("form", {
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"])),
            disabled: _ctx.loading
          }, [
            _createVNode(_component_app_input, {
              class: "mb-3",
              placeholder: "mail@domain.com (*)",
              modelValue: _ctx.model.email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.email) = $event)),
              validations: _ctx.v$.email
            }, null, 8, ["modelValue", "validations"]),
            _createVNode(_component_app_input, {
              class: "mb-3",
              type: "password",
              placeholder: "Password (*)",
              modelValue: _ctx.model.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.password) = $event)),
              validations: _ctx.v$.password
            }, null, 8, ["modelValue", "validations"]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_app_button, {
                  name: "Sign in",
                  theme: "primary",
                  class: "btn-block",
                  onClick: _withModifiers(_ctx.login, ["prevent"])
                }, null, 8, ["onClick"])
              ])
            ])
          ], 40, _hoisted_7),
          _createElementVNode("p", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: { name: _ctx.ROUTE_NAME_PASSWORD.FORGOT }
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ])
    ])
  ]))
}